import gql from 'graphql-tag';
import { senderDataFragment } from './sender-data.fragment';
import { recepientDataFragment } from './recepient-data.fragment';

export const messageFragment = gql`
  fragment messageFragment on Message {
    ID
    body
    senderData {
      ...senderDataFragment
    }

    recepientData {
      ...recepientDataFragment
    }
    creationTime
  }
  ${senderDataFragment}
  ${recepientDataFragment}
`;
